import { render } from "./QuestionCardForm.vue?vue&type=template&id=04a70cef"
import script from "./QuestionCardForm.vue?vue&type=script&lang=js"
export * from "./QuestionCardForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__